import { downloadDemoOrganizationResetStreetList } from "../../../../../../../../../../../../../../../../../api/kehrblatt/demo-data"
import type { DownloadStreetListsOperations } from "../../../actions/downloadStreetLists"

export const downloadStreetListsOperations: DownloadStreetListsOperations = {
  download: ({ organizationId, jobId, audience, statusToken, signal }) =>
    downloadDemoOrganizationResetStreetList(organizationId, jobId, audience, {
      statusToken,
      signal,
    }),
}
